export const SOURCE_COLOR_MUSE_CARD = 'colorMuseCardHex'; //color-muse-card
export const SOURCE_COLOR_MUSE_FABRIC = 'colorMuseFabricHex'; //color-muse-fabric
export const SOURCE_PICO_SRGB = 'picoSrgbHex'; //pico-srgb
export const SOURCE_PICO_ADOBE_RGB = 'picoAdobeSrgbHex'; //pico-adobe-rgb
export const SOURCE_KETTLEWELL = 'kettlewell'; //kettlewell
